import React from 'react';
import { CSSMailItemFooter } from '../styles';
import { WidgetEmailsImapAttachments } from '../JRCWidgetEmailsImapAttachments';

export const WidgetEmailsItemFooter = ({ count }: { count: number }) => {
    return (
        <CSSMailItemFooter>
            <WidgetEmailsImapAttachments count={count} />
        </CSSMailItemFooter>
    );
};
